import { render, staticRenderFns } from "./FreightRateTableTemplateRoutesBlock.vue?vue&type=template&id=42d01a73&"
import script from "./FreightRateTableTemplateRoutesBlock.vue?vue&type=script&lang=js&"
export * from "./FreightRateTableTemplateRoutesBlock.vue?vue&type=script&lang=js&"
import style0 from "./FreightRateTableTemplateRoutesBlock.vue?vue&type=style&index=0&id=42d01a73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports